(function () {
  const curProductIndex = {};
  const maxProductIndex = {};
  
  function showBtnBlock() {
    const productList = document.querySelectorAll(".look-product .product-list");
    productList.forEach((item) => {
      const curSection = item.closest("section");
      const sectionClass = Array.from(curSection.classList)[0];
      const productItems = item.querySelectorAll('.product-item');
      const productContain = item.parentElement;
      maxProductIndex[sectionClass] = productItems.length - 1;
      if (!productItems.length || productItems.length <= 2 ) {
        return;
      }
      const containWidth = productContain.clientWidth;
      const itemWidth = (productItems[0].clientWidth + 20);
      const allItemWidth = (productItems[0].clientWidth + 20) * productItems.length;
      const btnBlock = productContain.parentElement.querySelector(".product-button-block");
      if (!btnBlock) {
        productContain.style.width = "96%";
        return;
      }
      if (containWidth > allItemWidth) {
        btnBlock.style.display = "none";
        return;
      }
      const curWidth = containWidth - 72;
      const maxIndex = productItems.length - Math.floor(curWidth / itemWidth);
      console.log(productItems.length, curWidth, itemWidth, maxIndex)
      maxProductIndex[sectionClass] = maxIndex;
      productContain.style.width = `${curWidth}px`;
      btnBlock.style.opacity = 1;
    })
  }
  showBtnBlock();
  
  function changeDot(index, sectionClass) {
    const lookDot = document.querySelectorAll(
      `.${sectionClass} .look__dot__holder`
    );
    lookDot.forEach((dom) => {
      if (dom.dataset.productIndex == index) {
        dom.classList.add("is-active");
      } else {
        dom.classList.remove("is-active");
      }
    });
  }
  
  function changeList(index, sectionClass) {
    const productList = document.querySelector(
      `.${sectionClass} .product-list`
    );
    const productItem = document.querySelectorAll(
      `.${sectionClass} .product-item`
    );
    productList.style.left = `-${182 * index}px`;
    const prevBtn = document.querySelector(
      `.${sectionClass} .product-button.prev`
    );
    prevBtn.classList.remove("disabled");
    const nextBtn = document.querySelector(
      `.${sectionClass} .product-button.next`
    );
    nextBtn.classList.remove("disabled");
    if (index == 0) {
      prevBtn.classList.add("disabled");
    }
    if (index >= maxProductIndex[sectionClass]) {
      nextBtn.classList.add("disabled");
    }
  }
  
  function scrollDivLeft(curDom, targetLeft) {
    const currentLeft = parseInt(curDom.scrollLeft, 10) || 0;
    const abs = Math.abs(targetLeft - currentLeft);
    if (abs >= 10) {
      requestAnimationFrame(function () {
        curDom.scrollLeft =
          currentLeft < targetLeft ? currentLeft + 10 : currentLeft - 10;
        scrollDivLeft(curDom, targetLeft);
      });
    }
  }
  
  function clickDot(e) {
    const classArr = Array.from(e.target.classList);
    if (!classArr.length || !classArr.includes("look__dot")) {
      return;
    }
    const productIndex = Number(e.target.innerText);
    const curSection = e.target.closest("section");
    const sectionClass = Array.from(curSection.classList)[0];
    if (typeof curProductIndex[sectionClass] == "undefined") {
      curProductIndex[sectionClass] = productIndex;
    }
    changeDot(productIndex, sectionClass);
    const productButton = document.querySelectorAll(
      `.${sectionClass} .product-button`
    );
    if (productButton.length) {
      const curIndex = Math.min(maxProductIndex[sectionClass], productIndex);
      changeList(curIndex, sectionClass);
      return;
    }
    const productContain = document.querySelector(
      `.${sectionClass} .product-contain`
    );
    const curLeft = productIndex * 180;
    const productList = document.querySelector(
      `.${sectionClass} .product-list`
    );
    const maxLeft = productList.clientWidth - productContain.clientWidth;
    scrollDivLeft(productContain, Math.min(curLeft, maxLeft));
  }
  
  function clickBtn(e) {
    const btnDom =
      e.target.tagName != "BUTTON" ? e.target.closest('button') : e.target;
    const classArr = Array.from(btnDom.classList);
    if (classArr.includes("disabled")) {
      return;
    }
    const curSection = e.target.closest("section");
    const sectionClass = Array.from(curSection.classList)[0];
    if (typeof curProductIndex[sectionClass] == "undefined") {
      curProductIndex[sectionClass] = 0;
    }
    let curTo = null;
    if (classArr.includes("prev") && curProductIndex[sectionClass] > 0) {
      curTo = curProductIndex[sectionClass] - 1;
    }
    if (classArr.includes("next") && curProductIndex[sectionClass] < maxProductIndex[sectionClass]) {
      curTo = curProductIndex[sectionClass] + 1;
    }
    if (!curTo && curTo !== 0) {
      return;
    }
    curProductIndex[sectionClass] = curTo;
    changeDot(curProductIndex[sectionClass], sectionClass);
    changeList(curProductIndex[sectionClass], sectionClass);
  }
  
  const sectionDotList = document.querySelectorAll(
    ".all-info-look .look-image"
  );
  sectionDotList.forEach((item) => {
    item.addEventListener("click", clickDot);
  });
  const sectionBtnList = document.querySelectorAll(
    ".all-info-look .product-button"
  );
  sectionBtnList.forEach((item) => {
    item.addEventListener("click", clickBtn);
  });
})();
